<template>

    <div class="container">

        <p class="headline">FEATURED NEWS</p>

        <div id="carousel">
            <div id="slide-container">

                <a v-for="single_news, index in news" :tabindex="index" class="slide featuredNewsSlideItem" :data-slideIndex="index" @click="toNews(single_news.slug)" :key="index">
        
                    <div class="image"
                    v-bind:style="{
                        background: get_background_image(single_news),
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundColor: 'black',
                        backgroundPosition: 'center 80%'
                    }"
                    ></div>

                    <div class="overlay">

                        <div class="content">

                            <div class="subline__date">
                                <p class="subline">{{ single_news.subline }}</p>
                                <p class="date"> {{ single_news.created_on }}</p>
                            </div>
                            <p class="name">{{ single_news.title }}</p>
                            <p class="short_desc">{{ single_news.short_description }}</p>

                        </div>

                        <a class="see_more" :href="'/news/' + single_news.slug">
                            <p>SEE MORE INFO</p>
                        </a>
                        
                    </div>

                </a>

            </div>
        </div>

    </div>

</template>
<script>
    export default {
        data(){
            return {
                text: "Vue3 component."
            }
        },
        props: ['news'],
        mounted(){
            this.autoplayCarousel();
        },
        methods: {
            autoplayCarousel() {
                const carouselEl = document.getElementById("carousel");
                const slideContainerEl = carouselEl.querySelector("#slide-container");
                const slideEl = carouselEl.querySelector(".slide");
                let slideWidth = slideEl.offsetWidth;
                // Add click handlers
                // document.querySelector("#back-button")
                //     .addEventListener("click", () => navigate("backward"));
                // document.querySelector("#forward-button")
                //     .addEventListener("click", () => navigate("forward"));
                // document.querySelectorAll(".slide-indicator")
                //     .forEach((dot, index) => {
                //         dot.addEventListener("click", () => navigate(index));
                //         dot.addEventListener("mouseenter", () => clearInterval(autoplay));
                //     });
                // Add keyboard handlers
                document.addEventListener('keydown', (e) => {
                    if (e.code === 'ArrowLeft') {
                        clearInterval(autoplay);
                        navigate("backward");
                    } else if (e.code === 'ArrowRight') {
                        clearInterval(autoplay);
                        navigate("forward");
                    }
                });
                // Add resize handler
                window.addEventListener('resize', () => {
                    slideWidth = slideEl.offsetWidth;
                });
                // Autoplay
                const autoplay = setInterval(() => navigate("forward"), 5000);

                const elements = document.getElementsByClassName('featuredNewsSlideItem');
                
                for (let index = 0; index < elements.length; index++) {
                    const element = elements[index];
                    element.addEventListener("mouseenter", () => {
                        clearInterval(autoplay)
                        element.classList.add('inFocus');
                    });
                    element.addEventListener("mouseleave", () => {
                        if(element.classList.contains('inFocus')){
                            this.autoplayCarousel();
                            element.classList.remove('inFocus');
                        } 
                    });
                };

                // slideContainerEl.addEventListener("mouseenter", () => clearInterval(autoplay));

                // Slide transition
                const getNewScrollPosition = (arg) => {
                    const gap = 10;
                    const maxScrollLeft = slideContainerEl.scrollWidth - slideWidth;
                    if (arg === "forward") {
                        const x = slideContainerEl.scrollLeft + slideWidth + gap;
                        return x <= maxScrollLeft ? x : 0;
                    } else if (arg === "backward") {
                        const x = slideContainerEl.scrollLeft - slideWidth - gap;
                        return x >= 0 ? x : maxScrollLeft;
                    } else if (typeof arg === "number") {
                        const x = arg * (slideWidth + gap);
                        return x;
                    }
                }
                const navigate = (arg) => {
                    slideContainerEl.scrollLeft = getNewScrollPosition(arg);
                }
                // Slide indicators
                // const slideObserver = new IntersectionObserver((entries, observer) => {
                //     entries.forEach(entry => {
                //         if (entry.isIntersecting) {
                //             const slideIndex = entry.target.dataset.slideindex;
                //             carouselEl.querySelector('.slide-indicator.active').classList.remove('active');
                //             carouselEl.querySelectorAll('.slide-indicator')[slideIndex].classList.add('active');
                //         }
                //     });
                // }, { root: slideContainerEl, threshold: .1 });
                // document.querySelectorAll('.slide').forEach((slide) => {
                //     slideObserver.observe(slide);
                // });
            },


            get_background_image(single_news)
            {
                return "url('" + '/image/' + single_news.media_path + '/' + single_news.featured_image + "')"
            },

            toNews(slug){
                if(window.innerWidth < 837){
                    window.location.href = '/news/' + slug;
                }
            }
        }
    }
</script>
<style lang="scss" scoped>

    .container{
        display: flex;
        flex-direction: column;

        .headline{
            font-family: "DIN Next LT Pro Bold";
            font-style: normal;
            font-size: 30px;
            line-height: 36px;
            color: #FFFFFF;
            margin: 0;
            text-align: center;
        }
    }

    * {
        box-sizing: border-box;
        scrollbar-color: transparent transparent; /* thumb and track color */
        scrollbar-width: 0px;
    }

    *::-webkit-scrollbar {
        width: 0;
    }

    *::-webkit-scrollbar-track {
        background: transparent;
    }

    *::-webkit-scrollbar-thumb {
        background: transparent;
        border: none;
    }

    * {
        -ms-overflow-style: none;
    }

    #carousel {
        width: 100%;
        max-width: 1350px;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        position: relative;
    }  

    .slide-indicators {
        display: flex;
        justify-content: center;
    }

    .slide-indicator {
        height: 44px;
        width: 50px;
        display: flex;
        justify-items: center;
        cursor: pointer;
    }

    .slide-indicator:after {
        content: "";
        background-color: #878787;
        height: 10px;
        margin-top: 10px;
        width: 40px;
    }

    .slide-indicator.active:after,
    .slide-indicator:hover:after {
        background-color: #000000;
    }

    .slide-banner {
        background-color: #000000;
        color: #ffffff;
        position: absolute;
        left: 0;
        bottom: 20px;
        padding: 15px;
        font-size: 2.5vw;
    }

    .slide-banner a {
        color: #ffffff;
    }

    #slide-container {
        scroll-snap-type: x mandatory;
        overflow-x: scroll;
        overflow-y: hidden;
        display: flex;
        align-items: center;
        height: 100%;
        gap: 10px;
        -webkit-overflow-scrolling: touch;
        scroll-behavior: smooth;
    }
    .slide {
        scroll-snap-align: center;
        position: relative;
        min-width: 100%;
        // padding-top: 50%;

        // display: block;
        position: relative;
        width: 100%;
        // max-width: 1350px;
        height: 250px;
        border-radius: 10px;

        border-bottom-left-radius: 15px; // fix overlay

        // filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

        border-bottom: 5px solid #ED1163;

        cursor: pointer;

        margin-top: 55px;
        margin-bottom: 100px;

        overflow: hidden;

        .image{
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 10px;
            transition: all .55s ease;
        }

        .overlay{
            clip-path: polygon(25% 0, 100% 0%, 100% 100%, 0% 100%);
            border-radius: 10px;

            width: 100%;
            max-width: 646px;
            height: 100%;
            position: absolute;
            top: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.5);

            transition: all .3s ease;

            overflow: hidden;

            .content{
                display: flex;
                flex-direction: column;
            
                width: 440px;
                height: calc(100% - 60px);
                justify-content: flex-start;
                margin-left: auto;
                margin-right: 25px;
                margin-top: 0;
                padding: 30px 0;


                .subline__date{
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    justify-content: space-between;


                    .subline{
                        font-family: 'DIN Next LT Pro Regular';
                        font-style: normal;
                        // font-weight: 400;
                        font-size: 12px;
                        line-height: 18px;
                        /* or 150% */

                        text-transform: uppercase;

                        transition: all .3s ease;

                        color: #ED1163;
                        margin: 0;
                    }

                    .date{
                        font-family: 'DIN Next LT Pro Regular';
                        font-style: normal;
                        // font-weight: 400;
                        font-size: 12px;
                        line-height: 18px;
                        /* identical to box height, or 150% */

                        text-transform: uppercase;

                        color: #FFFFFF;
                        margin: 0;
                    }
                }

                .name{
                    font-family: 'DIN Next LT Pro Regular';
                    font-style: normal;
                    // font-weight: 500;
                    font-size: 50px;
                    line-height: 50px;
                    // line-height: 100%;
                    /* or 50px */
                    
                    min-height: 100px;
                    max-height: 100px;
                    overflow-y: hidden;

                    text-transform: uppercase;

                    // height: 100px;
                    max-width: 400px;
                    color: #F9F9F9;
                    margin: 0;

                    // margin-bottom: 36px;
                }   

                .short_desc{
                    font-family: 'DIN Next LT Pro Regular';
                    font-style: normal;
                    // font-weight: 400;
                    font-size: 16px;
                    line-height: 20px;
                    /* or 125% */

                    text-transform: lowercase;

                    color: #F9F9F9;
                    margin: 0;
                    max-width: 400px;

                    min-height: 60px;
                    overflow-y: hidden;
                }
            }

            .see_more{
                display: block;
                width: 100%;
                max-width: 316px;
                height: 51px;

                background: rgba(0, 0, 0, 0.4);
                box-shadow: 2px -4px 6px rgba(0, 0, 0, 0.2);
                border-radius: 0px 10px;

                position: absolute;
                left: 0;
                bottom: -51px;
                opacity: 0;

                transition: all .3s ease;
                text-decoration: none;

                &:hover{
                    background: #ED1163;
                }

                p{
                    font-family: 'DIN Next LT Pro Regular';
                    font-style: normal;
                    // font-weight: 400;
                    font-size: 20px;
                    line-height: 51px;
                    /* identical to box height, or 100% */

                    text-align: center;
                    text-transform: uppercase;

                    color: #F9F9F9;
                    margin: 0;
                }
            }
        }

        &:hover{

            .overlay{
                clip-path: none;
                background: linear-gradient(90deg, rgba(237, 17, 99, 0.5) 9.27%, rgba(92, 44, 144, 0.5) 100%);
                max-width: 100%;

                .content{
                    .subline__date{

                        .subline{
                            color: white;
                        }

                    }
                } 

                .see_more{
                    opacity: 1;
                    bottom: 0;
                }
            }

            .image{
                transform: scale(1.1);
            }

        }

    }

    @media screen and (max-width: 836px) {
        #slide-container{
            width: 90%;
            margin: auto;
        }

        .container .headline{
            padding: 0 24px;
            font-size: 22px;
            line-height: 26px;
        }

        .slide{
            margin-bottom: 74px;

            .overlay{
                clip-path: none;
                padding: 0 24px;

                .content{
                    width: 100%;
                    padding-top: 22px;

                    .name{
                        font-size: 30px;
                        line-height: 30px;

                        // white-space: nowrap;
                        text-overflow: ellipsis;
                        min-height: 87px;
                        max-height: 103px;
                        overflow: hidden;
                        margin: 6px 0;
                    }

                    .short_desc{
                        font-family: 'DIN Next LT Pro Light';
                    }

                }
            }

            &:hover{
                .overlay{

                    .see_more{
                        opacity: 0;
                        bottom: 51px;
                    }
                }
            }
        }

    }

</style>